import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import GSignInButton from "vue-google-signin-button";

Vue.use(GSignInButton);

export default {
    name: "google-widget",
    props: {
        type: {
            type    : String,
            default : "sing-in"
        },
    },
    data() {
        return {
            // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
            googleSignInParams: {
                client_id: process.env.VUE_APP_GOOGLE_IDENTITY,
            },
        };
    },
    components: {
        GSignInButton,
    },
    computed: {
        labelByType() {
            switch (this.type) {
                case "linked": {
                    return this.$t("linked");
                }
                default: {
                    return "Google";
                }
            }
        },
    },
    created() {
        // if (document.getElementById("scriptGoogleAuth")) {
        //     return;
        // }
        // const scriptTag = document.createElement("script");
        // scriptTag.src = "https://apis.google.com/js/api:client.js";
        // scriptTag.id = "scriptGoogleAuth";
        // document.head.appendChild(scriptTag);
    },
    methods: {
        ...mapActions({
            auth        : `auth/AUTH_WITH_SOCIAL`,
            linkAccount : `userContacts/LINK_ACCOUNT`,
            fetchUser   : `user/GET_USER_DATA`
        }),
        ...mapGetters({ user: "user/user" }),
        onSignInSuccess(googleUser) {
            const token     = googleUser.getAuthResponse("access_token").access_token;
            const profile   = googleUser.getBasicProfile();
            
            const params = {
                full_name   : profile.getName(),
                email       : profile.getEmail(),
                image       : profile.getImageUrl(),
                isSocial    : true,
                token       : token,
                provider    : "google",
                country_id  : 1
            };
            
            if (this.type === "sing-in") {
                const params = {
                    full_name   : profile.getName(),
                    email       : profile.getEmail(),
                    image       : profile.getImageUrl(),
                    isSocial    : true,
                    token       : token,
                    provider    : "google",
                    country_id  : 1
                };
                
                this.auth(params)
                    .then(() => {
                        this.$toasted.success(this.$t("successAuth"));
                        this.$toasted.success(this.$t("loadData"));
                        
                        this.fetchUser().then(() => {
                            let userLang = "en";
                            
                            if (this.user && this.user.languageInterface && this.user.languageInterface.value) {
                                userLang = this.user.languageInterface.value;
                            }
                            
                            // this.$router.push({ name: "courses" });
                            const redirect =
                                this.$route.query.redirect || `/${userLang}/courses`;
                            this.$router.push(redirect);
                        });
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.$router.replace({ name: "login", query: { ...params } });
                        }
                        
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.data.error.message);
                        }
                    });
            }
            if (this.type === "linked") {
                this.linkAccount(params)
                    .then(() => {
                        this.$toasted.success(this.$t("successLinkedAccount"));
                    })
                    .catch((error) => {
                        if (error.response.status === 409) {
                            this.$toasted.error(error.response.data.error.message_key);
                        }
                    });
            }
        },
        onSignInError(error) {
            console.log(error);
        },
    },
    destroyed() {
        // if (document.getElementById("scriptGoogleAuth")) {
        //     document.getElementById("scriptGoogleAuth").remove();
        // }
    },
};
